<!--*********************************************************************************************************************************************************************************************************************************-->


<link href="https://unpkg.com/bootstrap-css-only@4.4.1/css/bootstrap.min.css" rel="stylesheet">
<link href="https://unpkg.com/@fortawesome/fontawesome-free@5.15.1/css/all.css" rel="stylesheet">
<link href="https://unpkg.com/angular-calendar@0.28.22/css/angular-calendar.css" rel="stylesheet">
<link href="https://unpkg.com/flatpickr@4.6.6/dist/flatpickr.css" rel="stylesheet">


<!-- Header Section -->
<div class="page-header col-md-12 p-3">
    <div class="row">
      <div class="col-md-4">
        <h3 class="page-title" translate>All Appointments</h3>
        <ol class="breadcrumb bg-white p-0">
          <li class="breadcrumb-item active" aria-current="page">Appointment</li>
        </ol>
      </div>
      <div class="col-md-8 d-none d-md-flex justify-content-md-end align-items-center">

        <button class="btn mx-1 border border-white rounded"  (click)='backClicked()' translate ><i class="fa fa-times"></i> BACK</button>
      </div>
  
      <!-- Mobile Dropdown -->
      <div class="col-12 d-flex d-md-none justify-content-end">
        <div ngbDropdown class="d-flex d-md-none justify-content-end mt-2">
          <button class="btn btn-light border no-arrow" ngbDropdownToggle>
            <i class="fa fa-ellipsis-h"></i>
          </button>
          <div ngbDropdownMenu class="dropdown-menu-right">
            <a class="dropdown-item border-bottom p-2"  (click)='backClicked()' translate ><i class="fa fa-times mr-1"></i> BACK </a>
        
   
  </div>
  </div>
  </div>
  </div>
  </div>


<ul class="nav nav-tabs bg-white mt-2 text-center pt-5 d-flex justify-content-center">

  <li class="nav-item">
    <a class="nav-link active" style="cursor: pointer;" id="upcomingappointmentview" translate >Upcoming Appointments</a>
  </li>
    <li class="nav-item">
      <a class="nav-link active" style="cursor: pointer;" id="calendarview" translate >Calendar View</a>
    </li>

    <li class="nav-item">
        <a class="nav-link active" style="cursor: pointer;" id="customsearchview" translate >Search</a>
      </li>

      </ul>





<!--*********************************************************************************************************************************************************************************************************************************-->

<div id="upcomingappointment">


  

    <div class="col-md-12 bg-muted p-0  " style="min-height: 15%; background: white;">
        <div class="row  mx-1 py-3   border  bg-white" >
   
 
       
            <input class=" p-2  w-100 mx-2 text-center  "  type="text" placeholder="Search"  [(ngModel)]="searchText"
   aria-label="Search" translate >
 
 </div>
        <div class=" d-flex justify-content-between row w-85  mx-1">
        
      <div class=" col-md-12 box box-primary shadow-sm bg-white p-1 " style="min-width: 48%;"  >
            <div id="notificationSlide" class="carousel slide " data-ride="carousel">
    
                <!-- Indicators -->
                <ul class="carousel-indicators">
                    <li data-target="#assetSlide" data-slide-to="0" class="active"></li>
                    <li data-target="#assetSlide" data-slide-to="1"></li>
                    <li data-target="#assetSlide" data-slide-to="2"></li>
                </ul>
    
                <!-- The slideshow -->
                <div class="carousel-inner" >
                    <div class="carousel-item active">
                        <div class=" border p-3 m-1 rounded   " >
                            <h6 class="table-heading rounded text-white text-center p-3 " style="background-color: #132a42;" ><strong  translate>Upcoming Appointments</strong></h6>
                    <div  style="overflow:auto;" *ngIf="allbranchappointment!=['no appointment']" >
                        <table class="table w-100  text-center"  style="font-size: 12px;">
                                    
                           
                            <th class="p-2" translate> Full Name</th>
                            <th class="text-center p-2" translate>Request Type</th>
                            <th class="text-center p-2" translate>Phone</th>
                            <th class="text-center p-2" translate>Time In</th>
                            <th class="text-center p-2" translate>Time Out</th>
                            <th class="text-center p-2" translate>Date Submitted</th>
                            <th class="text-center p-2" translate>Status</th>
                            <th class="text-center p-2" translate>Action</th>
                           
                           
                            <tr  *ngFor='let list of allupcomingbranchappointment | filter:searchText' [ngClass]="{'completedstatus':list.status=='Completed','pendingstatus':list.status=='Pending','progressstatus':list.status=='In Progress','cancelledstatus':list.status=='Cancelled','noshowstatus':list.status=='No Show'}">
                                <td   class=""(click)=openAppointment(list) style="cursor: pointer;" >{{list.fullName}}</td>                           
                                <td class="text-center " (click)=openAppointment(list) style="cursor: pointer;"  >{{list.requestType}}</td>
                               <td class="text-center " (click)=openAppointment(list) style="cursor: pointer;" >{{list.phoneNumber}}</td>
                               <td class="text-center " (click)=openAppointment(list) style="cursor: pointer;" >{{list.timeIn | date:'yyyy-M-d h:mm a'}}</td>
                               <td class="text-center " (click)=openAppointment(list) style="cursor: pointer;" >{{list.timeOut | date:'yyyy-M-d h:mm a'}}</td>
                               <td class="text-center " (click)=openAppointment(list) style="cursor: pointer;" >{{list.dateSubmitted | date:'yyyy-M-d h:mm a'}}</td>
                              
                              
                              
                               <td  *ngIf="list.status=='' || list.status==null" class="bg-warning text-white text-center  " ><strong>{{list.status}}</strong></td>
                                <td  *ngIf="list.status=='Pending'" class="bg-warning text-white text-center  " ><strong>{{list.status}}</strong></td>
                                <td  *ngIf="list.status=='No Show'" class="bg-danger text-white text-center  " ><strong>{{list.status}}</strong></td>
                                <td  *ngIf="list.status=='In Progress'" class="bg-primary text-white text-center  " ><strong>{{list.status}}</strong></td>
                                <td  *ngIf="list.status=='Completed'" class="bg-success text-white text-center "><strong>{{list.status}}</strong></td>
                                <td  *ngIf="list.status=='Cancelled'" class=" bg-danger text-white  text-center  "><strong>{{list.status}}</strong></td>
                                <td  *ngIf="list.status==''" class="text-center  p-2"><strong>{{list.status}}</strong></td>
                                
                                <td *ngIf="isReceptionist() || isAdmin() || isSystemAdmin() ">
                                    <i class="fa fa-trash p-1" (click)="deleteAppointment(list)"></i>
                                    <i class="fa fa-edit text-info p-2" (click)="editAppointment(list)" ></i>
                                    <i class="fa fa-check-square text-success p-2" style="cursor: pointer;" (click)="completeAppointment(list)"></i></td>
                           
                        
                              
    
                           
                            </tr>
                        </table>
                   </div>
                        </div>
                    </div>
    
                  <!--  <div class="carousel-item ">
                        <div class=" border p-3 m-1 rounded  " >
                            <h6 class="table-heading   rounded text-white bg-info text-center p-3"><strong>Training Notification</strong></h6>
                       
                            <div  style=" height: 200px; overflow:auto;"  >
                                <table class="table w-100 text-center"  style=" font-size: 12px;">
                               <thead>
                                    <th class=" p-2" >Employee</th>
                                    <th class=" text-center p-2" >Training Name</th>
                                    <th class="text-center p-2" >Days Remaining</th>
                                    <th class="text-center p-2" >Expiry Date</th>
                                </thead>
                                 <tbody class="pt-4" style="overflow:auto;">
                                    <tr *ngFor='let list of allexpiringtraining'>
                                        <td  >{{list.fullName}}</td>
                                        <td class="text-center " routerLink="/training-main">{{list.trainingName}}</td>
                                        <td  *ngIf="list.daysremain <= 30 && list.daysremain > 20" class="text-success text-center  p-2" ><strong>{{list.daysremain}}</strong></td>
                                        <td  *ngIf="list.daysremain  <= 20 && list.daysremain > 10" class="text-warning text-center  p-2" ><strong>{{list.daysremain}}</strong></td>
                                        <td  *ngIf="list.daysremain  <= 10 && list.daysremain >= 0" class="text-danger text-center  p-2"><strong>{{list.daysremain}}</strong></td>
                                       
                                        <td class="p-1 text-center">{{list.expiry}}</td>
                                   
                                    </tr>
                                </tbody>
                                </table>
                                    
                            </div>
                    </div>
                    </div>-->
                
                </div>
    
                <!-- Left and right controls -->
               <!-- <a class="carousel-control-prev " href="#notificationSlide"  data-slide="prev">
                    <span class="carousel-control-prev-icon"></span>
                </a>
                <a class="carousel-control-next"   href="#notificationSlide" data-slide="next">
                    <span class="carousel-control-next-icon"></span>
                </a>--->
            </div>
          
    </div>
    
     
     
           
            </div>
    
            </div>

            


    </div>


<!------------------------------------------------------------------------------------------------------------------------------------------------------
    Calendar View
--------------------------------------------------------------------------------------------------------------------------------------------------->

      <div id="calendar">
<section class="content-header  mt-5 p-3 my-3 mx-1 rounded text-white " style="background-color: #132a42;">
    <div class="d-flex justify-content-between pt-1 align-items-center">
        <h3 ><strong translate>All Appointments - {{branch}}</strong></h3>
    </div>
</section>
<div class=" col-md-12 box box-primary rounded border-top border-primary shadow-sm bg-white p-5 "  style="min-width: 48%;"  >

<mwl-demo-utils-calendar-header
  [(view)]="view"
  [(viewDate)]="viewDate"
  
  (viewDateChange)="fetchEvents()"
  (viewChange)="fetchEvents()"
>
</mwl-demo-utils-calendar-header>

<ng-template #loading>
  <div class="text-center">
    <i class="fas fa-spin fa-spinner fa-5x"></i> <br />
    Loading events...
  </div>
</ng-template>

<div *ngIf="events$ | async; else loading; let events">
  <div [ngSwitch]="view">
    <mwl-calendar-month-view
      *ngSwitchCase="'month'"
      [viewDate]="viewDate"
      [events]="events"
      [activeDayIsOpen]="activeDayIsOpen"
      (dayClicked)="dayClicked($event.day)"
      (eventClicked)="eventClicked($event.event)"
    >
    </mwl-calendar-month-view>
    <mwl-calendar-week-view
      *ngSwitchCase="'week'"
      [viewDate]="viewDate"
      [events]="events"
      (eventClicked)="eventClicked($event.event)"
    >
    </mwl-calendar-week-view>
    <mwl-calendar-day-view
      *ngSwitchCase="'day'"
      [viewDate]="viewDate"
      [dayStartHour]="8"
      [dayEndHour]="18"
      [events]="events"
      (eventClicked)="eventClicked($event.event)"
    >
    </mwl-calendar-day-view>
  </div>
</div>
</div>
      </div>


      <!------------------------------------------------------------------------------------------------------------------------------------------------------
    Custom Search View
--------------------------------------------------------------------------------------------------------------------------------------------------->

<div id="customsearch">
    <!--{{searchForm.value | json}}-->             
    <div class="row w-100 p-2 mx-1 mt-5 d-flex justify-content-between border border-dark rounded text-white bg-white" >
      
        <div >
            <a class="mt-2 text-dark  " data-toggle="collapse" href="#collapseLink" role="button" style="vertical-align:center ;"
              aria-expanded="false" aria-controls="collapseExample">
              <label style="font-size: x-large;" translate>Customize Appointment Search</label>
              </a>
            </div>

            <div>
            <div class="d-flex "><a class="btn  btn-sm  text-white " style="background-color: #132a42;"  data-toggle="collapse" href="#collapseLink" role="button"
                aria-expanded="false" aria-controls="collapseExample"><i class="fa fa-plus-square "></i> </a>
            </div>
              </div>


     </div>
 
     <div class="col-md-12 bg-muted p-0  " style="min-height: 15%; background: white;">
        <div class="collapse form-group"  id="collapseLink">
            <form [formGroup]="searchForm" class="text-center border border-light p-3">
                <div class="col-md-12 w-100">
                    <div class=" row">
            <div class="col-md-6 form-group py-2">
             
            <label for="sel1" class="text-left font-weight-bold form-label w-100" translate>Date Range Filter:</label>
            <input class="dateadded form-control" type="text" name="daterangeInput" daterangepicker [options]="options" (selected)="selectedDate($event, daterange)" />
        </div>

        <div class="col-md-4 form-group py-2">
            <label for="sel1" class="text-left font-weight-bold form-label w-100" translate>Sales Representative</label>
            <select class="form-control select2tag select2-hidden-accessible"
            formControlName="salesRep" id="salesRep" name="salesRep" 
            tabindex="-1" aria-hidden="true" 
           >
           <option value='' >SELECT</option>
            <option value='{{rep.userID}}' *ngFor="let rep of salesReplist">{{rep.fullName}}</option>
           
            
        </select>
            </div>
        <div class="col-md-2 form-group py-2 mt-4">
            <button class="btn btn-primary"  (click)="exportAsXLSX()" translate>Export To Excel</button>
            </div>
            </div>
        </div>
            <div class="col-md-12 ">
                <div class=" row">
            <div class="col-md-6 form-group py-2">
            <label class="text-left font-weight-bold p-2 rounded w-100" style="font-family:'DINPro'" translate>Request Type</label>
            <select class="form-control select2tag select2-hidden-accessible"
                formControlName="requestType" id="requestType" name="requestType" 
                tabindex="-1" aria-hidden="true" 
               >
               <option value=''>SELECT</option>
                <option value='Appointment'>Appointment</option>
                <option value="Browsing">Browsing</option> 
                <option value="Euro Lagno">Euro Lagno</option> 
                <option value="Walk-In">Walk-In</option>
                <option value="Online">Online</option>
                <option value="Phone">Phone</option>
                <option value="Email">Email</option>
                <option value="Email">Previous</option> 
                <option value="Virtual Appointment">Virtual Appointment</option>
                <option value="Virtual Inquiry">Virtual Inquiry</option>
            </select>
</div>
      
<div class="col-md-6 form-group py-2">
            <label class="text-left font-weight-bold p-2 rounded w-100" style="font-family:'DINPro'" translate>Status</label>
            <select class="form-control select2tag select2-hidden-accessible"
                formControlName="status" id="status" name="status" style="width: 100%;"
                tabindex="-1" aria-hidden="true">
                <option value=''>SELECT</option>
                <option value="In Progress">In Progress</option>
                <option value="Pending">Pending</option>
                <option value="Completed">Completed</option>
                <option value="Cancelled">Cancelled</option>
                <option value="No Show">No Show</option> 
                
            </select>
    </div>
   </div>
   <div class="text-center"><button 
   
    (click)=onSearchSubmit() class="btn  text-white bg-dark "
    style="align-content: center; " translate><i
        class="fa fa-check"></i> 
    Submit</button>
</div>
   </div>
</form>
</div>
        <div class=" d-flex justify-content-between row w-85 mt-2 mx-1">
         
       <div class=" col-md-12 box box-primary rounded border-top border-primary shadow-sm bg-white p-1 " style="min-width: 48%;"  >
             <div id="notificationSlide" class="carousel slide " data-ride="carousel">
     
                 <!-- Indicators -->
                 <ul class="carousel-indicators">
                     <li data-target="#assetSlide" data-slide-to="0" class="active"></li>
                     <li data-target="#assetSlide" data-slide-to="1"></li>
                     <li data-target="#assetSlide" data-slide-to="2"></li>
                 </ul>
     
                 <!-- The slideshow -->
                 <div class="carousel-inner" >
                     <div class="carousel-item active">
                         <div class=" border p-3 m-1 rounded   " >
                            <div class="p-1 mr-3">
                                <input class=" p-2 m-2 w-100 mx-2 text-center rounded "  type="text" placeholder="Search"  translate [(ngModel)]="allAptSearchText"
                       aria-label="Search" >
                     </div>
                             <h6 class="table-heading rounded text-white text-center p-3  bg-dark" ><strong translate>All Appointment</strong></h6>
                     <div  style="overflow:auto;" >
                         <table class="table w-100  text-center"  style="font-size: 12px;">
                                     
                            
                             <th class="p-2" translate > Full Name</th>
                             <th class="text-center p-2" translate >Request Type</th>
                             <th class="text-center p-2" translate >Phone</th>
                             <th class="text-center p-2" translate >Time In</th>
                             <th class="text-center p-2" translate >Time Out</th>
                             <th class="text-center p-2" translate >Date Submitted</th>
                             <th class="text-center p-2" translate >Status</th>
                             <th class="text-center p-2" translate >Action</th>
                            
                            
                             <tr  *ngFor='let list of searchResult | filter:allAptSearchText'  [ngClass]="{'completedstatus':list.status=='Completed','pendingstatus':list.status=='Pending','progressstatus':list.status=='In Progress','cancelledstatus':list.status=='Cancelled','noshowstatus':list.status=='No Show'}">
                                 <td class="p-2"(click)=openAppointment(list) style="cursor: pointer;" >{{list.fullName}}</td>                           
                                 <td class="text-center p-2" (click)=openAppointment(list) style="cursor: pointer;"  >{{list.requestType}}</td>
                                <td class="text-center p-2" (click)=openAppointment(list) style="cursor: pointer;" >{{list.phoneNumber}}</td>
                                <td class="text-center p-2" (click)=openAppointment(list) style="cursor: pointer;" >{{list.timeIn | date:'yyyy-M-d h:mm a'}}</td>
                                <td class="text-center p-2" (click)=openAppointment(list) style="cursor: pointer;" >{{list.timeOut | date:'yyyy-M-d h:mm a'}}</td>
                                <td class="text-center p-2" (click)=openAppointment(list) style="cursor: pointer;" >{{list.dateSubmitted | date:'yyyy-M-d h:mm a'}}</td>
                               
                               
                               
                                <td  *ngIf="list.status=='' || list.status==null" class="bg-warning text-white text-center  p-2" ><strong>{{list.status}}</strong></td>
                                 <td  *ngIf="list.status=='Pending'" class="bg-warning text-white  text-center  p-2" ><strong>{{list.status}}</strong></td>
                                 <td  *ngIf="list.status=='No Show'" class="bg-danger text-white  text-center  p-2" ><strong>{{list.status}}</strong></td>
                                 <td  *ngIf="list.status=='In Progress'" class="bg-primary text-white  text-center  p-2" ><strong>{{list.status}}</strong></td>
                                 <td  *ngIf="list.status=='Completed'" class="bg-success text-white  text-center  p-2"><strong>{{list.status}}</strong></td>
                                 <td  *ngIf="list.status=='Cancelled'" class="bg-danger text-white  text-center  p-2"><strong>{{list.status}}</strong></td>
                                 <td  *ngIf="list.status==''" class="text-center  p-2"><strong>{{list.status}}</strong></td>
                                 
                                 <td *ngIf="isReceptionist() || isAdmin() || isSystemAdmin() ">
                                     <i class="fa fa-trash p-1" (click)="deleteAppointment(list)"></i>
                                     <i class="fa fa-edit text-info p-2" (click)="editAppointment(list)" ></i>
                                     <i class="fa fa-check-square text-success p-2" style="cursor: pointer;" (click)="completeAppointment(list)"></i></td>
                            
                         
                               
     
                            
                             </tr>
                         </table>
                    </div>
                         </div>
                     </div>
     
                 
                 </div>
     
          
             </div>
           
     </div>
     
      
      
            
             </div>
     
             </div>
 
             
 
 
          </div>

<!------------------------------------------------------------------------------------------------------------------------------------------
                        Success DeleteModal
                    ------------------------------------------------------------------------------------------------------------------------------------------>
                    <button id="openSuccessDeleteModalButton" [hidden]="true" data-toggle="modal" data-target="#SuccessDeleteModal">Open Modal</button>
                    <!-- Modal -->
                    <div id="SuccessDeleteModal" class="modal fade" role="dialog">
                        <div class="modal-dialog">
                    
                            <!-- Modal content-->
                            <div class="modal-content">
                                <div class="modal-header">
                    
                               <!-- <h4 class="modal-title text-success">SUCCESS</h4>
                                    <button type="button" class="close" data-dismiss="modal">&times;</button>-->
                                </div>
                                <div class="modal-body " style="background: black;">
                                    <div class="row p-5 ">
                                        <div class="col-sm-12 w-100">
                                            <div class="d-flex flex-column justify-content-between  row w-100 m-0">
                    
                    
                                                <img class="px-3"
                                                    style="display: block; margin-right: auto; margin-left: auto; max-height: 100px; max-width: 200px;"
                                                    src="./assets/logo2020w.png" />
                    
                                                <div class="w-100 text-center">
                                                    <h3 class="bg-black text-white pt-4" style="font-family:'DINPro';" translate>THANK YOU </h3>
                                                </div>
                    
                                                <div class="border  bg-white "></div>
                                                <div class="w-100 text-center">
                                                    <h4 class="bg-black text-white pt-4" style="font-family:'DINPro';" translate>Appointment has been deleted.</h4>
                                                </div>
                    
                                               
                    
                    
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-default text-center" (click)='getAllAppointmentForTableView()' data-dismiss="modal" translate>Close</button>
                                </div>
                            </div>
                    
                        </div>
                    </div>
                    
                    
                    <!------------------------------------------------------------------------------------------------------------------------------------------
                                           Error Modal
                                        ------------------------------------------------------------------------------------------------------------------------------------------>
                    <button id="openErrorModalButton" [hidden]="true" data-toggle="modal" data-target="#ErrorModal">Open Modal</button>
                    <!-- Modal -->
                    <div id="ErrorModal" class="modal fade" role="dialog">
                        <div class="modal-dialog">
                    
                            <!-- Modal content-->
                            <div class="modal-content">
                                <div class="modal-header">
                    
                                    <h4 class="modal-title text-danger" translate>ERROR</h4>
                                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                                </div>
                                <div class="modal-body text-danger">
                                    <p>{{error}}</p>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-default" (click)='backClicked()' data-dismiss="modal" translate>Close</button>
                                </div>
                            </div>
                    
                        </div>
                        </div>








 <!------------------------------------------------------------------------------------------------------------------------------------------
                        Success Complete Modal
                    ------------------------------------------------------------------------------------------------------------------------------------------>
                    <button id="openSuccessCompleteModalButton" [hidden]="true" data-toggle="modal" data-target="#SuccessCompleteModal">Open Modal</button>
                    <!-- Modal -->
                    <div id="SuccessCompleteModal" class="modal fade" role="dialog">
                        <div class="modal-dialog">
                    
                            <!-- Modal content-->
                            <div class="modal-content">
                                <div class="modal-header">
                    
                               <!-- <h4 class="modal-title text-success">SUCCESS</h4>
                                    <button type="button" class="close" data-dismiss="modal">&times;</button>-->
                                </div>
                                <div class="modal-body " style="background: black;">
                                    <div class="row p-5 ">
                                        <div class="col-sm-12 w-100">
                                            <div class="d-flex flex-column justify-content-between  row w-100 m-0">
                    
                    
                                                <img class="px-3"
                                                    style="display: block; margin-right: auto; margin-left: auto; max-height: 100px; max-width: 200px;"
                                                    src="./assets/logo2020w.png" />
                    
                                                <div class="w-100 text-center">
                                                    <h3 class="bg-black text-white pt-4" style="font-family:'DINPro';" translate>THANK YOU </h3>
                                                </div>
                    
                                                <div class="border  bg-white "></div>
                                                <div class="w-100 text-center">
                                                    <h4 class="bg-black text-white pt-4" style="font-family:'DINPro';" translate>Appointment has been marked as complete.</h4>
                                                </div>
                    
                                               
                    
                    
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-default text-center" (click)='getAllAppointmentForTableView()' data-dismiss="modal" translate>Close</button>
                                </div>
                            </div>
                    
                        </div>
                    </div>








